/* eslint-disable jest/valid-describe */
/* eslint-disable jest/valid-title */
import React from 'react';
import { styled, typography, color, __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';

const Label = styled.span`
  ${typography}
  ${color('neutral', '800')}
  padding-bottom: ${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xxs)};
  padding-top: calc(${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xxs)} / 2);
`;

const DSMobileFooterAction = ({ label, icon, onClick }) => (
  <Grid
    data-testid="ds-mobile-footer-action"
    rows={['auto'].concat(label ? 'min-content' : 'none')}
    justifyContent="center"
    role="button"
    onClick={onClick}
  >
    <Grid justifyContent="center" alignItems="center">
      {React.cloneElement(icon, {
        'data-testid': 'ds-mobile-footer-action-icon',
        size: !label ? 'l' : 'm',
      })}
    </Grid>

    {label && (
      <Grid justifyContent="center">
        <Label fontSize="11px">{label}</Label>
      </Grid>
    )}
  </Grid>
);

const actionProps = {
  /** Action label */
  label: PropTypes.string.description('Action label'),
  /** Action icon */
  icon: PropTypes.element.description('Action icon'),
  /** onClick callback */
  onClick: PropTypes.func.description('onClick callback'),
};

DSMobileFooterAction.displayName = 'DSMobileFooterAction';
const DSMobileFooterActionWithSchema = describe(DSMobileFooterAction).description('Mobile footer action');
DSMobileFooterActionWithSchema.propTypes = actionProps;

export { DSMobileFooterAction, DSMobileFooterActionWithSchema };
